import React from 'react'
import { Input } from 'sputnik-ui'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

export default function RtspLinkExplain({ ...props }) {
  const { t } = useTranslation(['device'])

  const defaultStyles = {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 32,
    marginBottom: 24,
  }
  return (
    <Box sx={{ ...defaultStyles, ...props.style }}>
      <Typography>{t('devices:cameras.third_party.settings')}</Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          marginBottom: 24,
          marginTop: 16,
        }}
      >
        <Box sx={{ display: 'inline-flex' }}>
          <Typography color="textSecondary">
            {t('devices:cameras.third_party.settings_video.resolution')}
          </Typography>
          &nbsp;
          <Typography>1080</Typography>
        </Box>
        <Box sx={{ display: 'inline-flex' }}>
          <Typography color="textSecondary">
            {t('devices:cameras.third_party.settings_video.frames_per_sec')}
          </Typography>
          &nbsp;
          <Typography>25</Typography>
        </Box>
        <Box sx={{ display: 'inline-flex' }}>
          <Typography color="textSecondary">
            {t('devices:cameras.third_party.settings_video.frame_type')}
          </Typography>
          &nbsp;
          <Typography>CBR</Typography>
        </Box>
        <Box sx={{ display: 'inline-flex' }}>
          <Typography color="textSecondary">
            {t('devices:cameras.third_party.settings_video.bitrate')}
          </Typography>
          &nbsp;
          <Typography>1024</Typography>
        </Box>
        <Box sx={{ display: 'inline-flex' }}>
          <Typography color="textSecondary">
            {t('devices:cameras.third_party.settings_video.frame_frequency')}
          </Typography>
          &nbsp;
          <Typography>50</Typography>
        </Box>
        <Typography>
          {t('devices:cameras.third_party.stream_warning')}
        </Typography>
      </Box>
    </Box>
  )
}
